import React from 'react';
import { cx } from '@emotion/css';
import { Grid, Paper } from '@mui/material';
import { useGoogleTranslator } from '@/hooks/useGoogleTranslator';
import colors from '@/theme/colors';
import { BodyMedium } from '@/design-system';
import styles from './MessageBanner.styles';

interface MessageBannerProps {
  subheadline: string;
  iconSrc?: any;
  children?: any;
  variant?: string;
  dataTestId?: string;
  footer?: React.ReactNode;
}

export const MessageBanner = ({
  subheadline,
  iconSrc,
  children,
  dataTestId,
  variant = 'default',
  footer,
}: MessageBannerProps): React.ReactElement => {
  const subheadlineTranslated = useGoogleTranslator(subheadline);
  const subheadlineVariantsColors = {
    default: colors.prussian,
    prussian: colors.white,
    pop: colors.charcoal,
    warning: colors.charcoal,
  };
  return (
    <Grid item xs={12}>
      <Paper
        className={cx(styles.welcomeContent, styles.variants[variant])}
        data-testid={dataTestId}
      >
        <div className={styles.flexRow}>
          <div className={styles.iconDefault}>
            <img src={iconSrc} alt="Manage Icon" data-testid="manageIcon" />
          </div>
          <div>
            <BodyMedium
              color={subheadlineVariantsColors[variant]}
              data-testid="subheadline"
              nonTranslate
            >
              <span dangerouslySetInnerHTML={{ __html: subheadlineTranslated }} />
            </BodyMedium>
            {children && (
              <div className={styles.flexColumn}>
                <div className={styles.ctasContainer}>
                  <div className={styles.ctas} data-testid="ctaButtonsContainer">
                    {children}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {footer && <div className={styles.footer}>{footer} </div>}
      </Paper>
    </Grid>
  );
};
